import { Mail } from 'lucide-react';
import {
  ResumeCard,
  ResumeCardHeader,
} from '@/components/commercial/proposals/shared/summary-components';

interface ContractRecipientCardProps {
  signerEmail: string;
  signerName?: string;
}

export function ContractRecipientCard({ signerEmail, signerName }: ContractRecipientCardProps) {
  return (
    <ResumeCard>
      <ResumeCardHeader title="Destinatário" icon={<Mail className="h-4 w-4 text-gray-400" />} />
      <div className="space-y-1 px-5 py-4">
        {signerName && (
          <p className="break-words text-sm font-semibold text-gray-900">{signerName}</p>
        )}
        <p className="break-words text-sm text-gray-600">{signerEmail}</p>
      </div>
    </ResumeCard>
  );
}
